import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { List, X, Phone } from "@phosphor-icons/react";
import { LOGO_URL } from "../../lib/api";
import { useContent, pick } from "../../lib/content";
import { useSite } from "../../lib/site";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/gallery", label: "Gallery" },
  { to: "/locations", label: "Areas" },
  { to: "/blog", label: "Journal" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const site = useSite();
  const c = useContent();
  const loc = useLocation();

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-atc-black text-white border-b-2 border-atc-red" data-testid="site-header">
      <div className="container-max flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
          <img src={LOGO_URL} alt="ATC Home Pros" className="h-12 w-12 object-contain" />
          <div className="leading-none">
            <div className="font-display text-xl tracking-tight">ATC HOME PRO'S</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/60 mt-1">{pick(c, "global.header_tagline", "Since Quality Counts")}</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" data-testid="main-nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-heading uppercase tracking-widest text-sm transition-colors ${
                  isActive ? "text-atc-red" : "text-white/80 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {site?.phone && (
            <a href={`tel:${site.phone}`} className="flex items-center gap-2 text-white/80 hover:text-white font-mono text-sm" data-testid="header-phone">
              <Phone size={16} weight="bold" />
              {site.phone}
            </a>
          )}
          <Link to="/contact" className="btn-primary" data-testid="header-cta">
            {pick(c, "global.header_cta_label", "Free Estimate")}
          </Link>
        </div>

        <button
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={28} weight="bold" /> : <List size={28} weight="bold" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-atc-black border-t border-atc-red/30" data-testid="mobile-menu">
          <div className="container-max py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `font-heading uppercase tracking-widest text-base ${isActive ? "text-atc-red" : "text-white"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" className="btn-primary mt-2" data-testid="mobile-cta">
              {pick(c, "global.header_cta_label", "Free Estimate")}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
